import { deepCopy, formatUTCDate, formatValidTime, parseUTCDate } from "../../../utils/FPEUtils";
import LegendACOS from "../legend/LegendACOS";
import ContentsBase from "./ContentsBase";
import { WX_ID_ACOS } from "../../../store/WeatherContentsState";

class ACOS extends ContentsBase {
  static NAME = WX_ID_ACOS;
  setRevision;

  constructor(setRevision) {
    super('ACOS', 'ACOS', 'WX_WNI_VolcanicAsh_GPV');
    this.OPT_NAME = 'ACOS';
    this.setRevision = setRevision;
  }
  parseTimelist() {

    const index = this.dataReference.query("index").value();

    // 各火山の最新のAnnouncedDateのデータを抽出
    const latestDateEachVolcano = [];
    Object.keys(index).forEach((key) => {
      latestDateEachVolcano.push(index[key].reduce((a, c) => {
        return a.announced_date > c.announced_date ? a : c;
      }));
    })

    // 火山中最新のAnnouncedDateのデータを抽出
    const latestDateInTheVolcano = latestDateEachVolcano.reduce((a, c) => {
      return a.announced_date > c.announced_date ? a : c;
    });
    // 全火山中最新のAnnouncedDate
    const latestAnnouncedDate = parseUTCDate(latestDateInTheVolcano.announced_date);

    // 最新のAnnouncedDateをbasetimeに設定する
    const data = {basetime: formatUTCDate(latestAnnouncedDate, '%Y/%m/%d %H:%M:%S'), validtime: []};
    const basetimeDate = new Date(latestAnnouncedDate);

    // 30分未満だったら現正時に、30分以上だったら翌正時に
    if(latestAnnouncedDate.getUTCMinutes() < 30) {
      latestAnnouncedDate.setUTCMinutes(0, 0, 0);
    } else {
      latestAnnouncedDate.setUTCHours(latestAnnouncedDate.getUTCHours() + 1, 0, 0, 0);
    }

    for(let i = 0; i <= 24; i++) {
      data.validtime.push([
        formatUTCDate(latestAnnouncedDate, '%Y/%m/%d %H:%M:%S'),
        this.calcFt(basetimeDate, latestAnnouncedDate)
      ]);
      latestAnnouncedDate.setHours(latestAnnouncedDate.getHours() + 1);
    }
    data.validtime.reverse();
    this.validtimeList = [data];

    if(this.prevValidtime) {
      if(this.isDiffPrevDataBaseValid()) {
        this.setRevision();
      }
    }

    this.prevValidtime = deepCopy(this.validtimeList);
  }

  calcFt(basetime, validtime) {
    const timeDiff = validtime.getTime() - basetime.getTime();
    return Math.round(timeDiff / (1000 * 60 * 60));
  }

  getOpt(data, fpMode) {
    return new Promise(resolve => {
      const makeOpt = () => {
        this.shownTime = this.getValidtimeClosestToTheDateForBaseValid(data, fpMode);
        return {
          ACOS: {
            Basetime: this.shownTime.basetime,
            Validtime: this.shownTime.validtime,
            Visible: this.isVisible()
          }
        };
      }
      if (this.updated) {
        resolve(makeOpt());
      } else {
        const intervalId = setInterval(() => {
          if (!this.updated) return;
          clearInterval(intervalId);
          resolve(makeOpt());
        }, 500);
      }
    });
  }
  getLegend() {
    return {
      id: ACOS.NAME,
      label: 'ACOS',
      component: LegendACOS,
      contents: this
    }
  }
  getTimeInformation() {
    return {
      id: ACOS.NAME,
      label: 'ACOS',
      validTime: this.shownTime ? formatValidTime(this.shownTime.validtime[0]) : "---"
    }
  }
}

export default ACOS;